export class Boolean2StringValueConverter {
    toView(value: boolean) {
        if (value === true || value === false) {
            return value.toString();
        }
        return "";
    }
    fromView(value: string): boolean {
        if (value) {
            if (value.toLowerCase() == 'true') {
                return true;

            }
            if (value.toLowerCase() == 'false') {
                return false;
            }
        }
        return null;
    }
}